import React from "react";
import AutomationEngineeringContent from "../function-components/Courses/AutomationEngineeringContent";

function AutomationEngineering({bannerimg}) {
  return (
    <>
      <AutomationEngineeringContent bannerimg={bannerimg}/>
    </>
  );
}

export default AutomationEngineering;
